<template>
  <section>
    <div class="channel-selection" :style="{maxWidth: isPC? '90vw': '100vw'}">
      <!-- <el-radio-group v-model="strategyKey" @change="channelSort" style="margin-bottom: 8px;">
        <el-radio v-for="item in strategyList" :key="item.key" :label="item.key">{{item.value}}</el-radio>
      </el-radio-group> -->
      <vue-scroll style="height: 30vh;">
        <p v-for="item in channelListData" :key="item.channelCode" class="channel-text pointer" :class="[item.channelCode === channelCode ? 'channel-actived' : '']" @click="clickChannel(item)">
          {{item.agingGrade}}({{item.deliveryTime}},${{item.estimatedFreight | money}})
        </p>
      </vue-scroll>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
// 渠道选择策略
const strategyList = [
  {
    key: 1, // 最快的
    value: 'Sort By Time'
  },
  {
    key: 2, // 最便宜的
    value: 'Sort By Cost'
  }
]
export default {
  props: {
    channelList: {
      type: Array,
      default: () => []
    },
    termini: {
      type: String,
      default: () => 'US'
    }
  },
  data() {
    return {
      channelCode: '',
      strategyKey: 1,
      strategyList,
      channelListData: []
    }
  },
  watch: {
    channelList() {
      this.channelSort()
      this.setShowName()
    }
  },
  created() {
    this.$emit('strategyChange', this.strategyList.find(item => +item.key === +this.strategyKey))
  },
  methods: {
    channelSort() {
      const field = this.strategyKey === 1 ? ['deliveryDayNum', 'estimatedFreight'] : ['estimatedFreight', 'deliveryDayNum']
      this.channelListData = _.orderBy(this.channelList, field, ['asc', 'asc'])
      this.$emit('strategyChange', this.strategyList.find(item => +item.key === +this.strategyKey))
    },
    clickChannel(channel) {
      this.channelCode = channel.channelCode
      this.$emit('change', channel)
    },
    setDefaultChannelCode(channelCode) {
      this.channelCode = channelCode
    },
    setShowName() {
      // // 默认标准渠道   后端返回第一条设置为特快  第二条开始为普快
      if (this.channelList.length === 1) {
        this.$set(this.channelList[0], 'renderName', 'Standard Shipping')
      } else {
        this.channelList.forEach((e, i) => {
          i === 0 && this.$set(e, 'renderName', 'Fast Shipping')
          i !== 0 && this.$set(e, 'renderName', 'Standard Shipping')
        })
      }
      // 获取天数   US  CA
      // const allNeedDays = this.channelListData.map(e => {
      //   const s = e.deliveryTime.split('~')
      //   return parseInt(s[0])
      // })
      // let a = _.orderBy(allNeedDays)
      // this.channelListData.forEach(e => {
      //   const s = e.deliveryTime.split('~')
      //   if (['US', 'CA'].includes(this.termini)) {
      //     this.$set(e, 'renderName', parseInt(s[0]) === a[0] ? 'Fast Shipping' : 'Standard Shipping')
      //   } else {
      //     this.$set(e, 'renderName', 'Standard Shipping')
      //   }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-selection{
  .channel-text:hover{
    background: rgba(153, 196, 28, 0.07);
  }
  .channel-text {
    border-radius: 4px;
    padding: 10px 5px;
    white-space: wrap;
    span{
      display: inline-block;
      max-width: 200px;
    }
  }
  .channel-actived{
    background: rgba(153, 196, 28, 0.07);
    color: #99C41C;
  }
}
@media screen and (max-width: 1000px) {
  .channel-selection{
    max-width: 90vw;
    overflow: hidden;
  }
}
</style>
